import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mobile-list-data-container',
  template: `
    <span>{{ key }}</span>
    <span>{{ value }}</span>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class ListDataMobileContainerComponent {
  @Input() public key!: string;
  @Input() public value!: string | number | null;
}
